import { render, staticRenderFns } from "./pelatihan.vue?vue&type=template&id=134090cf&"
import script from "./pelatihan.vue?vue&type=script&lang=js&"
export * from "./pelatihan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QBtnGroup,QBtnDropdown,QList,QItem,QItemSection,QAvatar,QItemLabel,QDialog,QCard,QCardSection,QInput,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QBtnGroup,QBtnDropdown,QList,QItem,QItemSection,QAvatar,QItemLabel,QDialog,QCard,QCardSection,QInput,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
